import api from './api.config';
import app from './app.config';
import cms from './cms.config';
import links from './links.config';
import rocker from './rocker.config';
import onboarding from './onboarding.config';

export default {
  api,
  app,
  cms,
  links,
  rocker,
  onboarding,
};
